import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type FontScale = 16 | 18 | 20;

interface A11yState {
  fontScale: FontScale;
  reducedMotion: boolean;
  setFontScale: (scale: FontScale) => void;
  setReducedMotion: (value: boolean) => void;
}

export const useA11yStore = create<A11yState>()(
  persist(
    (set) => ({
      fontScale: 18,
      reducedMotion: false,
      setFontScale: (fontScale) => set({ fontScale }),
      setReducedMotion: (reducedMotion) => set({ reducedMotion }),
    }),
    {
      name: 'osfp-a11y',
      partialize: (state) => ({ fontScale: state.fontScale, reducedMotion: state.reducedMotion }),
    },
  ),
);
